import { useSite } from "@/context/SiteContext";
import { useLang } from "@/context/LanguageContext";
import { AlertTriangle } from "lucide-react";

const AR_RISK = "ينطوي تداول الأدوات المالية ذات الرافعة، بما في ذلك الفوركس والعقود مقابل الفروقات، على مستوى عالٍ من المخاطر وقد يؤدي إلى خسارة رأس مالك المستثمر. قد لا تكون هذه المنتجات مناسبة لجميع المستثمرين. تأكد من فهمك للمخاطر ومراعاة ظروفك المالية قبل التداول. الأداء السابق ليس مؤشراً على النتائج المستقبلية.";
const AR_IB = "تعمل MENAGroupFX كوسيط معرّف و/أو شريك تسويق وإحالة، وفقاً للترتيبات التعاقدية المطبقة على كل علاقة وساطة. قد تعرّف MENAGroupFX العملاء المحتملين بمزودي وساطة خارجيين. ما لم يُذكر خلاف ذلك صراحةً وبدعم من ترخيص تنظيمي مطبّق، لا تنفّذ MENAGroupFX صفقات العملاء ولا تحتفظ بحسابات تداول أو خدمات حفظ أو أموال تداول العملاء. تُقدَّم خدمات الوساطة من قبل الوسيط الخارجي المعني وفق شروطه وإطاره التنظيمي.";

export function RiskWarning({ className = "" }) {
  const { settings } = useSite();
  const { L, isAr } = useLang();
  const text = isAr ? AR_RISK : (settings.risk_warning || "Trading leveraged financial instruments involves a high level of risk and may result in the loss of your invested capital.");
  return (
    <div className={`flex gap-3 rounded-lg border border-white/10 bg-white/5 p-4 ${className}`} data-testid="risk-warning">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
      <p className="text-xs leading-relaxed text-slate-400">
        <span className="font-semibold text-slate-300">{L.disclosures.riskLabel} </span>
        {text}
      </p>
    </div>
  );
}

export function IBDisclosure({ className = "" }) {
  const { settings } = useSite();
  const { L, isAr } = useLang();
  const text = isAr ? AR_IB : (settings.ib_disclosure || "MENAGroupFX operates as an Introducing Broker and/or marketing and referral partner.");
  return (
    <div className={`text-xs leading-relaxed text-slate-400 ${className}`} data-testid="ib-disclosure">
      <span className="font-semibold text-slate-300">{L.disclosures.ibLabel} </span>
      {text}
    </div>
  );
}
